/// <reference path="../dts/jquery.d.ts" />
import { BObject } from '../Objects/BObject';
import { BMotion } from '../Animations/BMotion';
import { MotionPropertyUI } from './MotionPropertyUI';
import { BMotionObject } from '../Objects/BMotionObject';
import { bezieApp } from '../main';
import { BezieApp } from '../BezieApp';
import { ObjectPropertyUI } from './ObjectPropertyUI';

export module UIUpdate{

    //SELECTION CHANGE LISTENER

    export interface SelectionChangeListener {
        onUpdate(obj: BObject | null, multipleSelected: Boolean): void;
    }

    var selectionChangeListeners: SelectionChangeListener[];

    selectionChangeListeners = [];

    export function addSelectionChangeListener(listener: SelectionChangeListener){
        if(listener){
            //console.log("adding selection change listener");
            selectionChangeListeners.push(listener);
        }
    }

    export function removeSelectionChangeListener(listener: SelectionChangeListener){
        if(listener){
            for(var index = 0; index  < selectionChangeListeners.length; index++){
                if(selectionChangeListeners[index] == listener){
                    selectionChangeListeners.splice(index, 1)
                    //console.log("removed selection change listener");
                }
            }
        }
    }

    export function notifySelectionChangeListeners(obj: BObject | null, multipleSelected: Boolean){
        //console.log("notifying selection change listeners : "+selectionChangeListeners.length);
        if(selectionChangeListeners.length > 0){
            for(var listener of selectionChangeListeners){
                listener.onUpdate(obj, multipleSelected);
            }
        }
    }


    //OBJECT UPDATE LISTENER

    export interface ObjectUpdateListener {
        onUpdate(obj: BObject): void;
    }

    var objectUpdateListeners: ObjectUpdateListener[];

    objectUpdateListeners = [];

    export function addObjectUpdateListener(listener: ObjectUpdateListener){
        if(listener){
            //console.log("adding obj update listener");
            objectUpdateListeners.push(listener);
        }
    }

    export function removeObjectUpdateListener(listener: ObjectUpdateListener){
        if(listener){
            for(var index = 0; index  < objectUpdateListeners.length; index++){
                if(objectUpdateListeners[index] == listener){
                    objectUpdateListeners.splice(index, 1)
                    //console.log("removed object update listener");
                }
            }
        }
    }

    function notifyObjectUpdateListeners(obj: BObject | null){
        //console.log("notifying listeners : "+objectUpdateListeners.length);
        if(obj && objectUpdateListeners.length > 0){
            for(var listener of objectUpdateListeners){
                listener.onUpdate(obj);
            }
        }
    }

    export function updatePropertiesUI(srcObj : BObject | null){
        notifyObjectUpdateListeners(srcObj);
    }

    //PLAYBACK UI    

    export interface PlaybackUpdateListener {
        onUpdate(curFrame: number): void;
        onTotalFramesChange(totalFrames: number): void;
    }

    var playbackUpdateListeners: PlaybackUpdateListener[];

    playbackUpdateListeners = [];

    export function addPlaybackUpdateListener(listener: PlaybackUpdateListener){
        if(listener){
            //console.log("adding playback update listener");
            playbackUpdateListeners.push(listener);
        }
    }

    export function removePlaybackUpdateListener(listener: PlaybackUpdateListener){
        if(listener){
            for(var index = 0; index  < playbackUpdateListeners.length; index++){
                if(playbackUpdateListeners[index] == listener){
                    playbackUpdateListeners.splice(index, 1)
                    //console.log("removed play back update listener");
                }
            }
        }
    }

    function notifyPlaybackUpdateListeners(curFrame: number){
        if(playbackUpdateListeners.length > 0){
            for(var listener of playbackUpdateListeners){
                listener.onUpdate(curFrame);
            }
        }
    }

    export function updatePlaybackUI(frameNumber : number){
        notifyPlaybackUpdateListeners(frameNumber);
    }

    export function notifyTotalFramesChange(totalFrames: number){
        if(playbackUpdateListeners.length > 0){
            for(var listener of playbackUpdateListeners){
                listener.onTotalFramesChange(totalFrames);
            }
        }
    }

    //RENDER LISTENER

    export interface RenderListener {
        onStart(): void;
        onFinish(blob: Blob|string): void;
        onProgress(val: number): void;
        onAbort(): void;
    }

    var renderListeners: RenderListener[];

    renderListeners = [];

    export function addRenderListener(listener: RenderListener){
        if(listener){
            //console.log("adding render listener");
            renderListeners.push(listener);
        }
    }

    export function removeRenderListener(listener: RenderListener){
        if(listener){
            for(var index = 0; index  < renderListeners.length; index++){
                if(renderListeners[index] == listener){
                    renderListeners.splice(index, 1)
                    //console.log("removed render listener");
                }
            }
        }
    }

    export function notifyonRenderStart(){
        //console.log("notifying render listeners : "+renderListeners.length);
        if(renderListeners.length > 0){
            for(var listener of renderListeners){
                listener.onStart();
            }
        }
    }

    export function notifyonRenderProgress(val: number){
        //console.log("notifying render listeners : "+renderListeners.length);
        if(renderListeners.length > 0){
            for(var listener of renderListeners){
                listener.onProgress(val);
            }
        }
    }

    export function notifyonRenderFinish(blob: Blob|string){
        //console.log("notifying render listeners : "+renderListeners.length);
        if(renderListeners.length > 0){
            for(var listener of renderListeners){
                listener.onFinish(blob);
            }
        }
    }

    export function notifyonRenderAbort(){
        //console.log("notifying render listeners : "+renderListeners.length);
        if(renderListeners.length > 0){
            for(var listener of renderListeners){
                listener.onAbort();
            }
        }
    }

    //FEATURE FLAG LISTENER

    export interface FeatureFlagChangeListener {
        onFeatureFlagUpdate(): void;
    }

    var featureFlagChangeListeners: FeatureFlagChangeListener[];

    featureFlagChangeListeners = [];

    export function addFeatureFlagChangeListener(listener: FeatureFlagChangeListener){
        if(listener){
            //console.log("adding featureFlagChangeListener");
            featureFlagChangeListeners.push(listener);
        }
    }

    export function removeFeatureFlagChangeListener(listener: FeatureFlagChangeListener){
        if(listener){
            for(var index = 0; index  < featureFlagChangeListeners.length; index++){
                if(featureFlagChangeListeners[index] == listener){
                    featureFlagChangeListeners.splice(index, 1)
                    //console.log("removed featureFlagChangeListener");
                }
            }
        }
    }

    export function notifyFeatureFlagChangeListeners(){
        //console.log("notifying selection change listeners : "+featureFlagChangeListeners.length);
        if(featureFlagChangeListeners.length > 0){
            for(var listener of featureFlagChangeListeners){
                listener.onFeatureFlagUpdate();
            }
        }
    }

    //OTHER METHODS

    export function addNewMotionPropertyUI(motionObj : BMotion){
        var srcObj = bezieApp.getScene().getSelectedObject() as BMotionObject;
        if(motionObj!=null && srcObj!=null){
            var uiModel = new MotionPropertyUI(motionObj.getId());
            uiModel.addNew(motionObj.TYPE);
            /*var jqueryObj = uiModel.getHtmlAsJQuery();
            console.log("jquery obj:"+jqueryObj);
            $("#prop-motions").append(jqueryObj);
            */
            $("#prop-motions").show();
        }
    }

    export function removeMotionPropertyUI(motionId : string){
        var srcObj = bezieApp.getScene().getSelectedObject() as BMotionObject;
        if(srcObj!=null && motionId!=null){
            var uiModel = new MotionPropertyUI(motionId);
            uiModel.remove();
        }
    }

    export function closeSaveToGifDialog(){
        console.log("calling close");
    }

    export function updatePlayPauseBtn(){
        if(bezieApp){
            if(bezieApp.getPlayPauseStatus() == BezieApp.PLAY_STATUS_PLAY){
                $('#playPauseBtn').removeClass('play').addClass('pause');
            }else{
                $('#playPauseBtn').removeClass('pause').addClass('play');
            }
        }
    }

    export function isSimplePallete(): boolean{
        if(bezieApp){
            return bezieApp.getColorPallete() == "a";
        }
        return true;
    }
}